import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c13980b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reserved-timer" }
const _hoisted_2 = {
  key: 0,
  class: "reserved-timer__text"
}
const _hoisted_3 = { class: "reserved-timer__msg" }
const _hoisted_4 = { class: "reserved-timer__sale" }
const _hoisted_5 = { class: "reserved-timer__green" }
const _hoisted_6 = { class: "reserved-timer__counter" }

import { reactive, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';

import { MODALS } from '@/@types/base';
import { ISubscription } from '@/@types/subscriptions';
import { useStore } from '@/store';
import { amplitudeInstance } from '@/analytics';

interface IState {
  time: number;
  timer: ReturnType<typeof setInterval> | null;
  activePackage: ISubscription | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservedTimer',
  setup(__props) {

const state: IState = reactive({
  time: 15 * 60, // 15min
  timer: null,
  activePackage: null,
});

const store = useStore();
const router = useRouter();

const subscriptionsList = computed<ISubscription[]>(() => {
  return store.getters['subscriptions/subscriptionsList'];
});

const userEmpty = computed<boolean>(() => {
  return store.getters['auth/userEmpty'];
});

const prettyTime = computed<string>(() => {
  const min = Math.floor(state.time / 60);
  const sec = Math.floor(state.time - min * 60);

  const formatMin = String(min).padStart(2, '0');
  const formatSec = String(sec).padStart(2, '0');

  return `${formatMin}:${formatSec}`;
});

const discountPercentages = computed<number>(() => {
  if (!state.activePackage) return 0;

  const { price, regular_price } = state.activePackage;

  return 100 - Math.floor((parseInt(price) * 100) / parseInt(regular_price));
});

const showPaymentPopup = function showPaymentPopup() {
  amplitudeInstance.logEvent('Get-it-now_clicked', {
    placement: 'timer',
  });

  if (!state.activePackage) {
    localStorage.removeItem('LimitedOffer');
    router.push({ name: 'Pricing' });
  } else {
    store.dispatch('base/setModalData', state.activePackage);

    if (userEmpty.value) {
      store.dispatch('base/setNeedOpenPaymentModal', true);
      store.dispatch('base/openModal', MODALS.AUTHORIZATION);
    } else {
      store.dispatch('base/openModal', MODALS.BASE_PAYMENT_MODAL);
    }
  }
};

onMounted(() => {
  const initialTime = localStorage.getItem('timerInitialTime');

  if (initialTime) {
    const startDate = new Date(initialTime);
    const endDate = new Date();
    const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
    const finalTime = Math.round(15 * 60 - seconds);

    state.time = finalTime > 0 ? finalTime : 0;

    if (state.time === 0) {
      store.dispatch('pricing/setDiscountVisible', false);
      store.dispatch('pricing/setTimerVisibility', false);
      store.dispatch('pricing/setTimerEnded', true);
    } else {
      store.dispatch('pricing/setDiscountVisible', true);
    }
  } else {
    localStorage.setItem('timerInitialTime', new Date().toString());

    store.dispatch('pricing/setDiscountVisible', true);
  }

  if (state.time !== 0) {
    state.timer = setInterval(() => {
      if (state.time > 0) {
        state.time -= 1;
      } else {
        if (state.timer) {
          clearInterval(state.timer);
        }

        store.dispatch('pricing/setTimerEnded', true);

        localStorage.removeItem('LimitedOffer');

        router.push({ name: 'Pricing' });

        setTimeout(() => {
          store.dispatch('pricing/setDiscountVisible', false);
          store.dispatch('pricing/setTimerVisibility', false);
          store.dispatch('pricing/setTimerEnded', true);
        }, 100);
      }
    }, 1000);

    state.activePackage =
      subscriptionsList.value.find((p) => p.screens.includes('lifetime_lto')) ??
      subscriptionsList.value[0];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.activePackage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('page_limited_offer_timer_msg')), 1),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(`${state.activePackage.name} plan`) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(`${_unref(discountPercentages)}% off`), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(prettyTime)), 1),
    _createElementVNode("button", {
      class: "reserved-timer__btn btn btn--prim",
      type: "button",
      onClick: showPaymentPopup
    }, _toDisplayString(_ctx.$t('form_button_get_it_now')), 1)
  ]))
}
}

})